import React, {forwardRef, useMemo} from 'react'
import {cx} from '@emotion/css'
import {imageProvider} from 'utils/imageProvider'

import {Box} from '@vio/atlas/helpers/Box'
import {Image} from '@vio/atlas/Image'
import {Text} from '@vio/atlas/Text'
import {FormattedMessageWrapper} from '@vio/core/src/localization/components/FormattedMessage'
import {MIN_THUMBNAIL_IMAGE_COUNT} from '@vio/shared/src/accommodation/LightboxGalleryDesktop/constant'

import {GalleryImageScrollWrapper, GridGallery} from './styles'

interface Props {
  hasSelectedImage?: boolean
  images: string[]
  onImageSelect: (image: string) => void
}
export const GalleryGridView = forwardRef<HTMLDivElement, Props>(
  ({images, onImageSelect, hasSelectedImage}, ref) => {
    const hasNoMoreImagesMessage = useMemo(
      () => images.length >= MIN_THUMBNAIL_IMAGE_COUNT,
      [images]
    )

    return (
      <>
        <GalleryImageScrollWrapper
          ref={ref}
          className={cx(
            hasNoMoreImagesMessage && '--has-no-more-images-message',
            hasSelectedImage && '--has-selected-image'
          )}
        >
          <GridGallery>
            {images.map((image, index) => (
              <Image
                id={`gallery-grid-image-${index}`}
                imageProvider={imageProvider}
                onClick={() => onImageSelect(image)}
                key={image}
                alt="gallery"
                url={image}
                borderRadius="xs"
              />
            ))}
          </GridGallery>
          {hasNoMoreImagesMessage && (
            <Box paddingTop="s700" paddingBottom="s700">
              <Text
                variant="bodyS"
                align="center"
                colorPath="content.neutral.secondary"
              >
                <FormattedMessageWrapper
                  id="noMorePhotosToShow"
                  defaultMessage="No more photos to show"
                />
              </Text>
            </Box>
          )}
        </GalleryImageScrollWrapper>
      </>
    )
  }
)
GalleryGridView.displayName = 'GalleryGridView'
